import { render, staticRenderFns } from "./TournamentBrackets.vue?vue&type=template&id=1c6eb09e&scoped=true&lang=pug&"
import script from "./TournamentBrackets.vue?vue&type=script&lang=js&"
export * from "./TournamentBrackets.vue?vue&type=script&lang=js&"
import style0 from "./TournamentBrackets.vue?vue&type=style&index=0&id=1c6eb09e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6eb09e",
  null
  
)

export default component.exports